import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const compileScss = async ({ deploymentId, scssData }) => {
    const data = await RequestManager.post({
        url: `/deployment/compileScss/v1/${deploymentId}`,
        body: {
            scssData
        }
    });

    return data;
};

const compileJs = async ({ deploymentId, jsData }) => {
    const data = await RequestManager.post({
        url: `/deployment/compileJs/v1/${deploymentId}`,
        body: {
            jsData
        }
    });

    return data;
};

const getAllDeploymentsInEnvironment = async (environmentId) => {
    const deployments = await RequestManager.get({
        url: `/deployment/environment/v1/${environmentId}`
    });
    return {
        ...deployments,
        ...deployments.data
    };
};

const getAllDeploymentsInDomain = async (
    domainId,
    size,
    firstCursor,
    lastCursor,
    prev,
    getLatest
) => {
    const urlParams = Utils.getUrlParams({
        size,
        prev,
        firstCursor,
        lastCursor,
        getLatest
    });

    const deployments = await RequestManager.get({
        url: `/deployment/domain/v1/${domainId}${urlParams}`
    });
    return {
        ...deployments,
        ...deployments.data
    };
};

const getDeployment = async (deploymentId, showSpinner = true) => {
    const deployment = await RequestManager.get({
        url: `/deployment/v1/${deploymentId}`,
        showSpinner
    });
    return deployment;
};

const saveBuildTimeConfig = async (deploymentId, body) => {
    const response = await RequestManager.post({
        url: `/deployment/buildTimeConfig/v1/${deploymentId}`,
        body
    });
    return response;
};

const getFormsWelcomeMessage = async (deploymentId) => {
    const response = await RequestManager.get({
        url: `/deployment/languages/welcomeMessage/v1/${deploymentId}`
    });
    return response;
};

const getBuildTimeConfig = async (deploymentId) => {
    const response = await RequestManager.get({
        url: `/deployment/buildTimeConfig/v1/${deploymentId}`
    });
    return response;
};

const getTemplateConfig = async (deploymentId) => {
    const response = await RequestManager.get({
        url: `/deployment/templateConfig/v1/${deploymentId}`
    });
    return response;
};

const createDeployment = async (environmentId, body) => {
    const response = await RequestManager.post({
        url: `/deployment/v2/${environmentId}`,
        body
    });
    return response;
};

const deleteDeployment = async (deploymentId) => {
    const response = await RequestManager.del({
        url: `/deployment/v1/${deploymentId}`
    });
    return response;
};

const updateDeployment = async (deploymentId, body) => {
    const response = await RequestManager.put({
        url: `/deployment/v1/${deploymentId}`,
        body
    });
    return response;
};

const updateFormsPreferences = async (deploymentId, body) => {
    const response = await RequestManager.patch({
        url: `/deployment/formsPreferences/v1/${deploymentId}`,
        body
    });
    return response;
};

const migrateDeployment = async (source, destination) => {
    const response = await RequestManager.put({
        url: `/deployment/migrate/v1/${source}/${destination}`
    });
    return response;
};

const deploy = (deploymentId) => {
    return RequestManager.get({
        url: `/deployment/deploy/v1/${deploymentId}`,
        showSpinner: false
    });
};

const buildOnPremDeployment = (deploymentId) => {
    return RequestManager.get({
        url: `/deployment/buildOnPrem/v1/${deploymentId}`,
        showSpinner: false
    });
};

const downloadOnPremBuild = (deploymentId) => {
    return RequestManager.get({
        url: `/deployment/downloadOnPremBuild/v1/${deploymentId}`,
        showSpinner: false
    });
};

const downloadApp = async (deploymentId) => {
    return RequestManager.get({
        url: `/deployment/downloadApp/v1/${deploymentId}`,
        showSpinner: false
    });
};

const uploadToResourcesFolder = async (id, data) => {
    return await RequestManager.post({
        url: `/deployment/uploadResources/v1/${id}`,
        body: data
    });
};

const getCustomerConfigDiff = async (deploymentId, customerConfigVersion) => {
    return await RequestManager.get({
        url: `/deployment/customerConfigDiff/v1/${deploymentId}/${customerConfigVersion}`
    });
};

const uploadLogo = async (id, data) => {
    return await RequestManager.post({
        url: `/deployment/logo/v1/${id}`,
        body: data
    });
};

const uploadFavicon = async (id, data) => {
    return await RequestManager.post({
        url: `/deployment/favicon/v1/${id}`,
        body: data
    });
};

const checkFaviconUploaded = async (id) => {
    return await RequestManager.get({
        url: `/deployment/favicon/v1/${id}`
    });
};

const deleteFavicon = async (id) => {
    return await RequestManager.del({
        url: `/deployment/favicon/v1/${id}`
    });
};

const deleteLogo = async (id) => {
    return await RequestManager.del({
        url: `/deployment/logo/v1/${id}`
    });
};

const checkLogoUploaded = async (id) => {
    return await RequestManager.get({
        url: `/deployment/logo/v1/${id}`
    });
};

const Deployment = {
    compileScss,
    compileJs,
    createDeployment,
    deleteDeployment,
    deploy,
    buildOnPremDeployment,
    downloadOnPremBuild,
    downloadApp,
    getAllDeploymentsInDomain,
    getAllDeploymentsInEnvironment,
    getDeployment,
    getFormsWelcomeMessage,
    getBuildTimeConfig,
    getTemplateConfig,
    migrateDeployment,
    updateDeployment,
    updateFormsPreferences,
    saveBuildTimeConfig,
    uploadToResourcesFolder,
    getCustomerConfigDiff,
    uploadLogo,
    deleteLogo,
    checkLogoUploaded,
    uploadFavicon,
    checkFaviconUploaded,
    deleteFavicon
};

export default Deployment;
